import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M19 4h-14a3 3 0 0 0 -3 3v10a3 3 0 0 0 3 3h14a3 3 0 0 0 3 -3v-10a3 3 0 0 0 -3 -3z","key":"svg-0"}]]

/**
 * IconRectangleFilled
 * @preview ![img](data:image/svg+xml;base64,PHN2ZwogIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIKICB3aWR0aD0iMjQiCiAgaGVpZ2h0PSIyNCIKICB2aWV3Qm94PSIwIDAgMjQgMjQiCiAgZmlsbD0iY3VycmVudENvbG9yIgogIGNsYXNzPSJpY29uIGljb24tdGFibGVyIGljb25zLXRhYmxlci1maWxsZWQgaWNvbi10YWJsZXItcmVjdGFuZ2xlIgo+CiAgPHBhdGggc3Ryb2tlPSJub25lIiBkPSJNMCAwaDI0djI0SDB6IiBmaWxsPSJub25lIiAvPgogIDxwYXRoIGQ9Ik0xOSA0aC0xNGEzIDMgMCAwIDAgLTMgM3YxMGEzIDMgMCAwIDAgMyAzaDE0YTMgMyAwIDAgMCAzIC0zdi0xMGEzIDMgMCAwIDAgLTMgLTN6IiAvPgo8L3N2Zz4=) - https://tabler.io/icons/icon/rectangle-filled
 * @see https://docs.tabler.io/icons/libraries/react - Documentation
 *
 */
const IconRectangleFilled = createReactComponent('filled', 'rectangle-filled', 'RectangleFilled', __iconNode);

export default IconRectangleFilled;